import { render, staticRenderFns } from "./WinningDialog.vue?vue&type=template&id=6b202b78&scoped=true&"
import script from "./WinningDialog.vue?vue&type=script&lang=js&"
export * from "./WinningDialog.vue?vue&type=script&lang=js&"
import style0 from "./WinningDialog.vue?vue&type=style&index=0&id=6b202b78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b202b78",
  null
  
)

export default component.exports